"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxFileSize = void 0;
function MaxFileSize(controller, dropzone, noticeHandler) {
    const maxFileSize = dropzone.getAttribute('data-js-file-max-size');
    if (!maxFileSize)
        return;
    const maxFileSizeBytes = parseFloat(maxFileSize) * 1024 * 1024;
    controller.onFileAdded((file) => {
        dropzone.classList.remove('file-size-error');
        if (file.size > maxFileSizeBytes) {
            controller.removeFileFromList(file);
            noticeHandler.showNotice([file]);
            dropzone.classList.add('file-size-error');
        }
    });
}
exports.MaxFileSize = MaxFileSize;
